import { withInstall } from '@lit-element/utils'

import Viewer from './src/viewer.vue'
import type { SFCWithInstall } from '@lit-element/utils'

export const LtViewer: SFCWithInstall<typeof Viewer> = withInstall(Viewer)
export default LtViewer

export * from './src/viewer'
